import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { formatExpiryDateTime, isPastDateTime, isToday } from 'utils/dateUtils';
import './TaskCard.css';

const TaskCard = (props) => {
  const [card, setCard] = useState({});
  const [isTitleHovered, setIsTitleHovered] = useState(false); // TITLE用ホバー状態

  useEffect(() => {
    setCard(props.card);
  }, [props.card]);

  // 設定画面呼び出しボタン
  const handleClickEdit = (e) => {
    e.preventDefault();
    props.callEditModal(card);
  };

  // TITLEクリックで完了トグル
  const handleClickTitleComplete = () => {
    props.updateCompleteCard({
      CARD_ID: card.CARD_ID,
      COMPLETE_FLG: card.COMPLETE_FLG ? 0 : 1,
    });
    setCard({ ...card, COMPLETE_FLG: card.COMPLETE_FLG ? 0 : 1 });
  };

  return (
    <div
      className={`card ${card.FREQUENCY ? 'card-auto-generated' : ''}`}
      {...props.provided.draggableProps}
      {...props.provided.dragHandleProps}
      ref={props.provided.innerRef}
      onDoubleClick={handleClickEdit}
    >
      <div
        className="title"
        onMouseEnter={() => setIsTitleHovered(true)}
        onMouseLeave={() => setIsTitleHovered(false)}
        style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}
      >
        {
          // ホバー時はチェックボックス、完了済みは常時チェックマーク表示
          isTitleHovered ? (
            card.COMPLETE_FLG === 0 ? (
              <RadioButtonUncheckedIcon
                sx={{ color: '#616368' }}
                fontSize="small"
                onClick={handleClickTitleComplete}
              />
            ) : (
              <CheckCircleIcon
                sx={{ color: '#30936a' }}
                fontSize="small"
                onClick={handleClickTitleComplete}
              />
            )
          ) : card.COMPLETE_FLG === 1 ? (
            <CheckCircleIcon
              sx={{ color: '#30936a' }}
              fontSize="small"
              onClick={handleClickTitleComplete}
            />
          ) : null
        }
        <span className={card.COMPLETE_FLG ? 'title-completed' : ''}>
          {card.FREQUENCY && (
            <span className="auto-badge">
              <AutorenewIcon sx={{ fontSize: 12 }} />
              {card.FREQUENCY === 'weekly' ? '毎週' : '毎月'}
            </span>
          )}
          {card.TITLE}
        </span>
      </div>
      <a href="#" className="avatar-container" onClick={handleClickEdit}>
        <Avatar sx={{ width: 24, height: 24 }}>
          <i className="material-symbols-rounded" style={{ fontSize: 16 }}>
            mode_edit
          </i>
        </Avatar>
      </a>

      <div className="expiry-comment">
        {/* 新着アイコン */}
        {card.NEW_FLG == 1 && (
          <div className="newcomment-icon">
            <NotificationsActiveIcon fontSize="small" />
            New
          </div>
        )}
        {card.EXPIRY && (
          <>
            <div
              className={`expiry ${
                card.COMPLETE_FLG
                  ? 'complete'
                  : isPastDateTime(card.EXPIRY)
                  ? 'overdue'
                  : isToday(card.EXPIRY)
                  ? 'deadline'
                  : ''
              }`}
            >
              <AccessTimeIcon fontSize="small" />
              <span
                style={{
                  marginLeft: '6px',
                  fontSize: '10pt',
                }}
              >
                {formatExpiryDateTime(card.EXPIRY)}
              </span>
            </div>
          </>
        )}
        {card.COMMENT_COUNT > 0 && (
          <div>
            <ChatBubbleOutlineIcon fontSize="small" />
            <span
              style={{
                marginLeft: '6px',
                fontSize: '10pt',
              }}
            >
              {card.COMMENT_COUNT}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskCard;
